module.exports = __webpack_public_path__ + "static/the-fault-in-our-stars-4c5daf2a99134e70ef7964b5a521ecab.jpg";